import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsClickableTagExamples: DSReactExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code`
                    function Component() {
                        return (
                            <>
                                <SpsClickableTag className="mt-1 ml-1">{"Blue"}</SpsClickableTag>
                                <SpsClickableTag className="mt-1 ml-1" kind={ClickableTagKind.GRAY}>{"Gray"}</SpsClickableTag>
                            </>
                        )
                    }
                `,
            },
            disabled: {
                react: code`
                    function Component() {
                        return (
                            <>
                                <SpsClickableTag className="mt-1 ml-1" disabled>{"Disabled"}</SpsClickableTag>
                            </>
                        )
                    }
                `,
            },
        },
    },
    button: {
        label: "Button",
        examples: {
            Remove: {
                react: code`
                function Component() {
                    return (
                        <>
                            <SpsClickableTag
                                className="mt-1 ml-1"
                                onRemove={() => console.log("removed")}
                            >
                                {"One"}
                            </SpsClickableTag>
                            <SpsClickableTag
                                className="mt-1 ml-1"
                                onRemove={() => console.log("removed")}
                            >
                                {"Two"}
                            </SpsClickableTag>
                        </>
                    )
                }
                `,
            },
            Add: {
                react: code`
                    function Component() {
                        return (
                            <>
                                <SpsClickableTag
                                    className="mt-1 ml-1"
                                    onAdd={() => console.log("added")}
                                >
                                    {"One"}
                                </SpsClickableTag>
                                <SpsClickableTag
                                    className="mt-1 ml-1"
                                    onAdd={() => console.log("added")}
                                >
                                    {"Two"}
                                </SpsClickableTag>
                            </>
                        )
                    }
                `,
            },
        },
    },
    link: {
        label: "Link",
        examples: {
            basic: {
                react: code`
                    function Component() {
                        return (
                            <>
                                <SpsClickableTag className="mt-1 ml-1" href="https://google.com">{"Link"}</SpsClickableTag>
                                <SpsClickableTag className="mt-1 ml-1" href="https://google.com" kind={ClickableTagKind.GRAY}>{"Link"}</SpsClickableTag>
                            </>
                        )
                    }
                `,
            },
            button: {
                react: code`
                function Component() {
                    return (
                        <>
                            <SpsClickableTag className="mt-1 ml-1" href="https://google.com" onRemove={() => console.log("removed")}>{"Remove"}</SpsClickableTag>
                            <SpsClickableTag className="mt-1 ml-1" href="https://google.com" onAdd={() => console.log("added")}>{"Add"}</SpsClickableTag>
                        </>
                    )
                }
                `,
            },
        },
    },
};
